import Typed from 'typed.js';
import YTPlayer from 'youtube-player';

export default {
  init() {
  },
  finalize() {

    /**
     * Be bold
     */

    new Typed('.be-typed', {
      stringsElement: '.be-typed-strings',
      typeSpeed: 60,
      backSpeed: 20,
      loop: true,
    });


    /**
     * Team Elevato video
     */

    let $videoEl  = $('.team-elevato .yt-player');

    if ($videoEl.length) {
      let videoElId = $videoEl.attr('id'),
          videoId   = $videoEl.data('video-id'),
          videoPlayer;

      videoPlayer = new YTPlayer(videoElId, {
        videoId: videoId,
        playerVars: {
          controls:       1,
          showinfo:       0,
          rel:            0,
          autoplay:       0,
          loop:           1,
          mute:           0,
          fs:             0,
          modestbranding: 1,
        },
      });
    }

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/about.js